import script from "./ViewWarehouseProject.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWarehouseProject.vue?vue&type=script&setup=true&lang=js"

import "./ViewWarehouseProject.vue?vue&type=style&index=0&id=0954322c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0954322c"]])

export default __exports__